module.exports = __webpack_public_path__ + "img/decoration.fd480e22.png";